import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ProtectedRoute from "./components/ProtectedRoute";
import StickyHireCTA from "./components/StickyHireCTA";
import MouseGlow from "./components/MouseGlow";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import useGoogleSiteVerification from "./hooks/useGoogleSiteVerification";

// Admin bundle is code-split — public visitors never download it.
const AdminLogin = lazy(() => import("./pages/admin/Login"));
const AdminForgotPassword = lazy(() => import("./pages/admin/ForgotPassword"));
const AdminResetPassword = lazy(() => import("./pages/admin/ResetPassword"));
const AdminDashboard = lazy(() => import("./pages/admin/Dashboard"));

const AdminFallback = () => (
  <div className="min-h-screen bg-black flex items-center justify-center" data-testid="admin-loading">
    <div className="h-8 w-8 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
  </div>
);

function ChromeShell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  useGoogleSiteVerification();
  return (
    <>
      {!isAdmin && <MouseGlow />}
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyHireCTA />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ChromeShell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/portfolio/:slug" element={<ProjectDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<Suspense fallback={<AdminFallback />}><AdminLogin /></Suspense>} />
              <Route path="/admin/forgot-password" element={<Suspense fallback={<AdminFallback />}><AdminForgotPassword /></Suspense>} />
              <Route path="/admin/reset-password" element={<Suspense fallback={<AdminFallback />}><AdminResetPassword /></Suspense>} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<AdminFallback />}><AdminDashboard /></Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<AdminFallback />}><AdminDashboard /></Suspense>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </ChromeShell>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
